import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material';

export type Fitting = 'cover' | 'contain';

interface StylesProps {
  fitting: Fitting;
}

export const useStyles = makeStyles<Theme, StylesProps>(() => ({
  wrapper: {
    position: 'relative',
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  image: ({ fitting }) => ({
    objectFit: fitting,
    width: '100%',
    height: '100%',
  }),
  imgIcon: {
    opacity: 0.5,
  },
  center: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
}));
